<template>
  <div class="side-bar colapsada">
    <MenuLogo></MenuLogo>
    <div class="menu-responsive">
      <ul v-if="!accesoRestringido" class="menu-principal">
        <MenuItem ruta="dashboard" claseCss="dashboard" :esActivo="activeMenu === 'dashboard'" texto="dashboard" @click="setActiveMenu('dashboard')">
        </MenuItem>
        <MenuItem
          v-if="puedeVerNuevaVenta"
          ruta="nueva-venta"
          claseCss="nueva-venta"
          :esActivo="activeMenu === 'nueva-venta'"
          texto="nueva_venta"
          @click="setActiveMenu('nueva-venta')"
        >
        </MenuItem>
        <MenuItem
          v-if="puedeVerNuevaVentaInmobiliaria"
          ruta="nueva-venta-inmobiliaria"
          claseCss="nueva-venta-inmobiliaria"
          :esActivo="activeMenu === 'nueva-venta-inmobiliaria'"
          texto="nueva_venta_inmobiliaria"
          @click="setActiveMenu('nueva-venta-inmobiliaria')"
        >
        </MenuItem>
        <MenuItem
          v-if="puedeVerBuscadorOfertas"
          ruta="buscador-ofertas"
          claseCss="buscador-ofertas"
          :esActivo="activeMenu === 'buscador-ofertas'"
          texto="buscador_ofertas"
          @click="setActiveMenu('buscador-ofertas')"
        >
        </MenuItem>
        <MenuItem
          v-if="puedeVerComparaciones"
          ruta="comparaciones"
          claseCss="comparaciones"
          :esActivo="activeMenu === 'comparaciones'"
          texto="comparador"
          @click="setActiveMenu('comparaciones')"
        >
        </MenuItem>
        <MenuItem
          v-if="puedeVerOperaciones"
          ruta="operaciones"
          claseCss="operaciones"
          :esActivo="activeMenu === 'operaciones'"
          texto="operaciones"
          @click="setActiveMenu('operaciones')"
        >
        </MenuItem>
        <MenuItem ruta="tramites" claseCss="tramites" :esActivo="activeMenu === 'tramites'" texto="tramites" @click="setActiveMenu('tramites')"> </MenuItem>
        <MenuItem
          v-if="puedeVerInmuebles"
          ruta="inmuebles"
          claseCss="inmuebles"
          :esActivo="activeMenu === 'inmuebles'"
          texto="inmuebles"
          @click="setActiveMenu('inmuebles')"
        >
        </MenuItem>
        <MenuItem
          v-if="puedeVerClientes"
          ruta="clientes"
          claseCss="clientes"
          :esActivo="activeMenu === 'clientes'"
          texto="clientes"
          @click="setActiveMenu('clientes')"
        >
        </MenuItem>
        <MenuItem
          v-if="puedeVerLiquidaciones"
          ruta="liquidaciones"
          claseCss="liquidaciones"
          :esActivo="activeMenu === 'liquidaciones'"
          texto="liquidaciones"
          @click="setActiveMenu('liquidaciones')"
        >
        </MenuItem>
        <MenuItem
          v-if="puedeVerAgentes"
          ruta="agentes"
          claseCss="agentes"
          :esActivo="activeMenu === 'agentes'"
          texto="agentes"
          @click="setActiveMenu('agentes')"
        >
        </MenuItem>
        <MenuItem
          v-if="puedeVerAgentesInmobiliaria"
          ruta="agentes-inmobiliaria"
          claseCss="agentes-inmobiliaria"
          :esActivo="activeMenu === 'agentes-inmobiliaria'"
          texto="agentes_inmobiliaria"
          @click="setActiveMenu('agentes-inmobiliaria')"
        >
        </MenuItem>
      </ul>
      <ul class="opciones-usuario">
        <MenuItem
          v-if="puedeVerComunicados && !accesoRestringido"
          ruta="comunicados"
          claseCss="comunicados"
          :esActivo="activeMenu === 'comunicados'"
          texto="comunicados"
          @click="setActiveMenu('comunicados')"
        >
        </MenuItem>
        <MenuItemNotificaciones
          claseCss="notificaciones"
          :esActivo="activeMenu === 'notificaciones'"
          texto="notificaciones"
          :numNotificaciones="numNotificacionesSinLeer"
          @click="$emit('toggle-notificationes')"
        >
        </MenuItemNotificaciones>
        <MenuItem ruta="mis-datos" claseCss="mis-datos" :esActivo="activeMenu === 'mis-datos'" texto="mis_datos" @click="setActiveMenu('mis-datos')">
        </MenuItem>
        <MenuItem
          v-if="puedeVerSoporte"
          ruta="soporte"
          claseCss="soporte"
          :esActivo="activeMenu === 'soporte'"
          texto="soporte"
          @click="setActiveMenu('soporte')"
        >
        </MenuItem>
      </ul>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed, inject, onMounted, ref } from "vue";
import MenuLogo from "@/components/menu/MenuLogo.vue";
import MenuItem from "@/components/menu/MenuItem.vue";
import MenuItemNotificaciones from "@/components/menu/MenuItemNotificaciones.vue";
import { useAuthorization } from "@/.shared/services/auth/authorization";
import { PermissionsApp } from "@/.shared/services/auth/authorization/authorization-service-impl";
import { useRoute } from "vue-router";
import { useEmpresaAgentesPortalRestringido } from "@/composables/empresaAgentesPortalRestringido";

const autho = useAuthorization();
const route = useRoute();
const { accesoRestringido } = useEmpresaAgentesPortalRestringido();
const numNotificacionesSinLeer = inject("numNotificacionesSinLeer", ref(0));
const activeMenu = ref<string>("");

onMounted(() => {
  let sideBar = document.querySelector(".side-bar") as any;
  let menuButton = document.querySelector(".menu-responsive-btn") as any;
  let menuResponsive = document.querySelector(".menu-responsive") as any;

  sideBar.onmouseover = () => {
    if (window.innerWidth > 992) {
      sideBar.classList.remove("colapsada");
    }
  };

  sideBar.onmouseout = () => {
    if (window.innerWidth > 992) {
      sideBar.classList.add("colapsada");
    }
  };

  menuButton.addEventListener("click", () => {
    if (menuResponsive.style.display === "block") {
      menuResponsive.style.display = "none";
    } else {
      menuResponsive.style.display = "block";
    }
  });

  activeMenu.value = determineActiveMenu();
});

// Función para determinar el menú activo según la ruta
const determineActiveMenu = () => {
  const path = route.path;
  if (path.includes("dashboard")) return "nueva-venta";
  if (path.includes("nueva-venta")) return "nueva-venta";
  if (path.includes("nueva-venta-inmobiliaria")) return "nueva-venta-inmobiliaria";
  if (path.includes("buscador-ofertas")) return "buscador-ofertas";
  if (path.includes("comparaciones")) return "comparaciones";
  if (path.includes("operaciones")) return "operaciones";
  if (path.includes("tramites")) return "tramites";
  if (path.includes("clientes")) return "clientes";
  if (path.includes("liquidaciones")) return "liquidaciones";
  if (path.includes("agentes-inmobiliaria")) return "agentes-inmobiliaria";
  if (path.includes("agentes")) return "agentes";
  if (path.includes("notificaciones")) return "notificaciones";
  if (path.includes("mis-datos")) return "mis-datos";
  if (path.includes("soporte")) return "soporte";
  if (path.includes("inmuebles")) return "inmuebles";
  if (path.includes("comunicados")) return "comunicados";
  return "";
};

const puedeVerComparaciones = computed(() => {
  return autho.hasPermission(PermissionsApp.EditSelfComparacionEnergia);
});

const puedeVerAgentes = computed(() => {
  return autho.hasPermission(PermissionsApp.EditAllUsuarios) || autho.hasPermission(PermissionsApp.EditSameCompanyAgentes);
});

const puedeVerAgentesInmobiliaria = computed(() => {
  return autho.hasPermission(PermissionsApp.EditSelfEmpresaInmobiliaria) || autho.hasPermission(PermissionsApp.EditSelfDelegacionInmobiliaria);
});

const puedeVerClientes = computed(() => {
  return autho.hasPermission(PermissionsApp.EditSameCompanyClientes) || autho.hasPermission(PermissionsApp.EditSelfClientes);
});

const puedeVerLiquidaciones = computed(() => {
  return autho.hasPermission(PermissionsApp.ViewSameCompanyLiquidaciones) || autho.hasPermission(PermissionsApp.ViewSameCompanyRappelsMensuales);
});

const puedeVerSoporte = computed(() => {
  return (
    autho.hasPermission(PermissionsApp.GetSameCompanyTickets) ||
    autho.hasPermission(PermissionsApp.GetSelfTickets) ||
    autho.hasPermission(PermissionsApp.GetSameDelegacionTickets)
  );
});

const puedeVerComunicados = computed(() => {
  return autho.hasPermission(PermissionsApp.ViewComunicados);
});

const puedeVerInmuebles = computed(() => {
  return autho.hasPermission(PermissionsApp.EditSameRealStateCompanyInmueble) || autho.hasPermission(PermissionsApp.EditSameRealStateAgencyInmueble);
});

const puedeVerNuevaVenta = computed(() => {
  return autho.hasPermission(PermissionsApp.ViewNuevaVenta);
});

const puedeVerNuevaVentaInmobiliaria = computed(() => {
  return autho.hasPermission(PermissionsApp.ViewNuevaVentaInmobiliaria);
});

const puedeVerOperaciones = autho.hasPermission(PermissionsApp.ViewNuevaVenta);

const puedeVerBuscadorOfertas = computed(() => {
  return autho.hasPermission(PermissionsApp.SearchOfertasEnergia);
});

const setActiveMenu = (menu: string) => {
  activeMenu.value = menu;
};
</script>

<style lang="scss">


.side-bar {
  width: 250px;
  height: 100%;
  padding: 10px;
  background-color: var(--background-surface-default);
  position: fixed;
  transition: all 0.5s ease;
  top: 0;
  box-shadow: 10px 0 10px rgba(0, 0, 0, 5%);
  display: flex;
  flex-direction: column;
  z-index: 99;

  &.colapsada {
    width: 80px;

    .logo-name,
    .menu-item-text,
    .notificaciones-number {
      opacity: 0;
      pointer-events: none;
    }

    .notificaciones-icon .status {
      opacity: 1;
    }
  }
}

.menu-principal {
  list-style: none;
  margin: 0;
  padding: 0;
}

.menu-item {
  display: flex;
  align-items: center;
  position: relative;
  padding: 10px 18px;
  color: var(--icon-default-default);
  cursor: pointer;
  transition: 0.5s ease;

  &:hover {
    color: var(--text-primary-default);
    transition: 0.5s ease;
    font-weight: bold;
  }
}

.menu-item::before {
  transition: 0.5s ease;
  content: "";
  position: absolute;
  right: -10px;
  height: 100%;
  border-left: 5px solid var(--border-primary-default);
  border-radius: 2px;
  opacity: 0;
  visibility: hidden;
}

.menu-item:hover::before {
  opacity: 1;
  visibility: unset;
}

.menu-item-icon {
  font-size: 1.3rem;
}

.menu-item-text {
  margin-left: 1rem;
  transition: opacity 0.6s ease;
  opacity: 1;
  text-wrap: nowrap;
}

.opciones-usuario {
  padding: 25px 0 0;
  border-top: 1px solid var(--border-default-default);
  margin-top: auto;
}

.notificaciones-number {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  background-color: var(--background-secondary-default);
  padding: 0.5rem 0.9rem;
  border-radius: 0.4rem;
  color: var(--text-secondary-on-action);
  opacity: 1;
  transition: 0.6s linear;
  font-weight: normal;
  line-height: 1rem;
}

.notificaciones-icon {
  position: relative;
}

.notificaciones-icon .status {
  position: absolute;
  top: 0;
  right: -1px;
  background-color: var(--background-secondary-default);
  height: 9px;
  width: 9px;
  border-radius: 50%;
  opacity: 0;
  transition: 0.6s linear;
}

.menu-item-icon::after {
  content: "";
  width: 24px;
  height: 24px;
  background-size: 24px;
  display: block;
  background-repeat: no-repeat;
  background-position: center;
}

/*OPCIONES MENÚ*/
.dashboard .menu-item-icon::after {
  background-image: url(../../assets/images/dashboard-off.svg);
}

.nueva-venta .menu-item-icon::after,
.nueva-venta-inmobiliaria .menu-item-icon::after {
  background-image: url(../../assets/images/nueva-venta-off.svg);
}

.comparaciones .menu-item-icon::after,
.buscador-ofertas .menu-item-icon::after {
  background-image: url(../../assets/images/comparador-off.svg);
}

.operaciones .menu-item-icon::after {
  background-image: url(../../assets/images/operaciones-off.svg);
}

.buscador-ofertas .menu-item-icon::after {
  background-image: url(../../assets/images/buscador-ofertas-off.svg);
}

.tramites .menu-item-icon::after {
  background-image: url(../../assets/images/tramites-off.svg);
}

.clientes .menu-item-icon::after {
  background-image: url(../../assets/images/clientes-off.svg);
}

.liquidaciones .menu-item-icon::after {
  background-image: url(../../assets/images/liquidaciones-off.svg);
}

.inmuebles .menu-item-icon::after {
  background-image: url(../../assets/images/mis-inmuebles-off.svg);
}

.agentes .menu-item-icon::after,
.agentes-inmobiliaria .menu-item-icon::after {
  background-image: url(../../assets/images/agentes-off.svg);
}

.notificaciones .menu-item-icon::after {
  background-image: url(../../assets/images/notificaciones.svg);
}

.mis-datos .menu-item-icon::after {
  background-image: url(../../assets/images/mis-datos-off.svg);
}

.soporte .menu-item-icon::after {
  background-image: url(../../assets/images/soporte-off.svg);
}

.comunicados .menu-item-icon::after {
  background-image: url(../../assets/images/comunicados-off.svg);
}

.dashboard:hover .menu-item-icon::after,
.dashboard.active .menu-item-icon::after {
  background-image: url(../../assets/images/dashboard-on.svg);
}

.nueva-venta:hover .menu-item-icon::after,
.nueva-venta.active .menu-item-icon::after,
.nueva-venta-inmobiliaria:hover .menu-item-icon::after,
.nueva-venta-inmobiliaria.active .menu-item-icon::after {
  background-image: url(../../assets/images/nueva-venta-on.svg);
}

.comparaciones:hover .menu-item-icon::after,
.comparaciones.active .menu-item-icon::after {
  background-image: url(../../assets/images/comparador-on.svg);
}

.buscador-ofertas:hover .menu-item-icon::after,
.buscador-ofertas.active .menu-item-icon::after {
  background-image: url(../../assets/images/buscador-ofertas-on.svg);
}

.operaciones:hover .menu-item-icon::after,
.operaciones.active .menu-item-icon::after {
  background-image: url(../../assets/images/operaciones-on.svg);
}

.tramites:hover .menu-item-icon::after,
.tramites.active .menu-item-icon::after {
  background-image: url(../../assets/images/tramites-on.svg);
}

.inmuebles:hover .menu-item-icon::after,
.inmuebles.active .menu-item-icon::after {
  background-image: url(../../assets/images/mis-inmuebles-on.svg);
}

.clientes:hover .menu-item-icon::after,
.clientes.active .menu-item-icon::after {
  background-image: url(../../assets/images/clientes-on.svg);
}

.liquidaciones:hover .menu-item-icon::after,
.liquidaciones.active .menu-item-icon::after {
  background-image: url(../../assets/images/liquidaciones-on.svg);
}

.agentes:hover .menu-item-icon::after,
.agentes.active .menu-item-icon::after,
.agentes-inmobiliaria:hover .menu-item-icon::after,
.agentes-inmobiliaria.active .menu-item-icon::after {
  background-image: url(../../assets/images/agentes-on.svg);
}

.mis-datos:hover .menu-item-icon::after,
.mis-datos.active .menu-item-icon::after {
  background-image: url(../../assets/images/mis-datos-on.svg);
}

.soporte:hover .menu-item-icon::after,
.soporte.active .menu-item-icon::after {
  background-image: url(../../assets/images/soporte-on.svg);
}

.notificaciones:hover .menu-item-icon::after,
.notificaciones.active .menu-item-icon::after {
  background-image: url(../../assets/images/notificaciones-on.svg);
}

.comunicados:hover .menu-item-icon::after,
.comunicados.active .menu-item-icon::after {
  background-image: url(../../assets/images/comunicados-on.svg);
}

/*MENÚ RESPONSIVE*/
.menu-responsive {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.menu-responsive-btn {
  display: none;
}

@media (max-width: 992px) {
  img.logo {
    width: 40px;
  }

  .menu-responsive-btn-container {
    align-self: center;
    margin-left: auto;
  }

  .menu-responsive-btn {
    display: block;
  }

  .side-bar,
  .side-bar.colapsada {
    width: 100%;
    height: 60px;
    padding: 1.1rem 1.2rem;
  }

  .menu-responsive {
    position: fixed;
    background: white;
    width: 100vw;
    height: 100vh;
    top: 60px;
    left: 0;
    display: none;
    padding: 1rem 1rem;
    border-top: 1px solid var(--border-default-default);
  }

  .side-bar.colapsada .logo-name,
  .side-bar.colapsada .menu-item-text,
  .side-bar.colapsada .notificaciones-number {
    opacity: 1;
    pointer-events: all;
  }
}
</style>
